import React from "react"
import Col from "react-bootstrap/Col"

const LayoutCol = ({ width, children }) => {
  return <Col lg={width}>{children}</Col>
}

export default LayoutCol
